import { useEffect } from "react";

export default function Toast({ message, type = "success", onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Auto-close after 3 seconds

    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor =
    type === "success"
      ? "bg-green-500"
      : type === "error"
      ? "bg-red-500"
      : "bg-blue-500";

  return (
    <div
    className={`fixed top-20 left-1/2 transform -translate-x-1/2 text-white px-4 py-2 rounded-lg shadow-lg transition-opacity duration-300 animate-fade-in ${bgColor}`}    >
      {message}
    </div>
  );
}
